import { client } from '@/client';

// 上传license文件
export function licenseUpload(params) {
  return client.form('/api/license/licenseUpload', params);
}

// 是否过期信息
export function getLicenseExpiredSoonPrompt() {
  return client.get('/api/license/getLicenseExpiredSoonPrompt');
}

// 获取license信息
export function getLicenseCache() {
  return client.get('/api/license/getLicenseCache');
}
